import { render, staticRenderFns } from "./FormPropertyDetails.vue?vue&type=template&id=7bbb1f8a&scoped=true"
import script from "./FormPropertyDetails.vue?vue&type=script&lang=js"
export * from "./FormPropertyDetails.vue?vue&type=script&lang=js"
import style0 from "./FormPropertyDetails.vue?vue&type=style&index=0&id=7bbb1f8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbb1f8a",
  null
  
)

export default component.exports